import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Right from '../../right/Right';
import Cookies from "js-cookie";
import './MealPlanner.css';
import { fetchInitialData } from "../../fetchData";
import MealRecipe from "./common/MealRecipe";
import Service from '../../service/Service';
import FooterMenu from "./common/FooterMenu";
import FilterCategory from './FilterCatagary';
import * as actions from './actions';
import withContext from "../../../withContext";

const service = new Service();

class Recipe extends Component {
    constructor(props) {
        super(props);
        console.log("Recipe page :", props);
        let serverSideData = {};
        let initialData = [];
        let mealSelRecp = [];
        let filterGroup = [];
        let recipeType = '';
        let metaTitle = '';
        let metaDescription = [];
        let isApp = '';
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData && serverSideData['result']) {
            initialData = serverSideData;
            mealSelRecp = serverSideData['result'];
            filterGroup = serverSideData.filtergroup;
        }
        var urlParam = (props.location.pathname + props.location.search);
        console.log("serverSideData", serverSideData);
        console.log("urlParam", urlParam.split("/")[3].split("-"));
        if (urlParam.split("/")[3]) {
            recipeType = urlParam.split("/")[3].replace("-recipes","");
            recipeType= recipeType && recipeType.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
            if(recipeType=="bookmarks?from=app" || recipeType=="bookmarks/?from=app" || recipeType=="Bookmarks?from=app" || recipeType=="Bookmarks/?from=app"){
                recipeType="Bookmarks";
            }
            metaTitle = recipeType + " Meal Plan & Recipes for Babies & Toddlers (8 to 24 Month Old)";
            metaDescription = [{ "name": "description", "content": "Create a healthy meal plans for your babies and toddlers by selecting the fittest and delicious " + recipeType + " recipe ideas." },
            { "name": "keywords", "content": recipeType + " recipes, " + recipeType + " recipe ideas, : " + recipeType + " recipes for babies and toddlers" },
            { "name": "atdlayout", "content": "" }];
        }else{
            if(urlParam.split("/")[3]=="bookmarks"){
                metaTitle = "Baby & Toddlers Meal Plans - FirstCry Parenting";
            }
        }
        if (this.props.location.search.includes('from=app')) {
            isApp=true;
        }
        this.state = {
            initialData: initialData,
            mealSelRecp: mealSelRecp,
            filterGroup: filterGroup,
            filterCount: 0,
            metaTitle: metaTitle,
            metaDescription: metaDescription,
            recipeType: recipeType,
            norecordFound:false,
            norecordFoundFilter:false,
            isApp: isApp
        };
        this.qnaPageNo = 1;
        this.totalCount = this.state.initialData.totalcount;
        if (this.props.params.page && this.props.params.page > 0) {
            this.qnaPageNo = parseInt(this.props.params.page);
        }
        this.maxScroll = 0;
        this.timeout = 0;
    }
    static initialAction(reqUrl, ftk, authData, uId, childData,cookieData) {
        console.log("authData---",authData);

        console.log("cookieData---",cookieData);
        var LatestFtk = '';
        if (cookieData && (cookieData.includes("app_ftk"))) {
         var cookieAry = cookieData.split(';');
             for (var i = 0; i < cookieAry.length; i++) {
                 if (cookieAry[i] && cookieAry[i].includes("app_ftk")) {
                    LatestFtk = cookieAry[i].split('app_ftk=')[1];
                 }         
             }         
         }
         console.log("LatestFtk=====>",LatestFtk);

         
        var Hosturl;
        // debugger;
        var header = {
            'Content-Type': 'application/json',
            'ftk': (ftk!="")?ftk:LatestFtk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        if (reqUrl.includes('/bookmark')) {
            Hosturl = reqUrl.split("/");
            var url = global.api_url + "dietplan/getallbookmarkrec";
        } else {
            var url = global.api_url + "dietplan/getreceipelisting";
        }
        console.log("reqUrl ** ", Hosturl);
        let body = JSON.stringify({
            "pageno": 1,
            "pagesize": 10
        });
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        console.log("mealSelRecp  ", this.state.mealSelRecp);
        console.log("filterGroup========================>", this.state.filterGroup)
        this.setState({ windowWidth: window.outerWidth });
        if(sessionStorage.getItem('mealfilterCount1')>=1 && Cookies.get('mealfilterCount') >=1){
            var filtercount = sessionStorage.getItem('mealfilterCount1');
            this.setState({filterCount:filtercount},()=>{
                this.mealScrollRecp(1,10);})
        }
        // console.log("windowWidth--", window.outerWidth);
        document.addEventListener("click", actions.domClick);
        this.pageData = this.pageData.bind(this);
        window.addEventListener("scroll", this.pageData, false);
        if (this.state.isApp) {
            actions.loadCallbackFile();
            var minheightdata = window.innerHeight - 49;
            document.querySelector('.data-container').style.minHeight = minheightdata + "px";
            document.querySelector('.footerList').style.bottom = "0px";
            // document.querySelector('.disclaimer-con').style.paddingBottom = "39px";
            document.querySelector('.sub-container').style.marginBottom = "0";
            document.querySelector('.sub-container').style.height = "auto";
            var minheightdata1 = window.innerHeight - 120;
            if (document.querySelector(".data-container").scrollHeight < minheightdata1 && (this.state.recipeType == "Bookmarks" || this.state.recipeType == "bookmarks?from=app")) {
                document.querySelector('.disclaimer-con').style.marginBottom = "31px";
                document.querySelector('.main-container').style.background = "#eee"
                document.querySelector('.disclaimer-con').style.width = "100%";
                document.querySelector('.disclaimer-con').style.position = "fixed";
                document.querySelector('.recipeBlock').style.border = "none";
                document.querySelector('.data-container').style.background = "#fff";
                document.querySelector('.disclaimer-con').style.bottom = "40px";
                var scheight = screen.height - 80 - 55;
                // document.querySelector('.sub-container') && (document.querySelector('.sub-container').style.height = scheight + "px");
                document.querySelector('.sub-container') && (document.querySelector('.sub-container').style.height = "auto");
            }
            setTimeout(() => {
                document.querySelector('.NoRecordsCont') && (document.querySelector('.main-container').style.background = "#fff");
                var scheight = screen.height - 80 - 55;
                document.querySelector('.NoRecordsCont') && (document.querySelector('.sub-container').style.height = scheight + "px");
                document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.minHeight = "auto");
                document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.height = "100%");
                document.querySelector('.NoRecordsCont') && (document.querySelector('.NoRecordsCont').style.height = "100%");
                document.querySelector('.NoRecordsCont') && (document.querySelector('.NoRecordsCont').style.padding = "45% 1px");
                document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.background = "#fff");
            }, 200);

        } else {
            document.querySelector('.data-container').style.minHeight = "unset";
        }
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1) || this.state.initialData['msg'] == -1) {
                service.showLoader();
                this.getRecipeListing();

            } else {
                localStorage.setItem('getRecipeListing', JSON.stringify(this.state.initialData));
            }

        } else {
            if (localStorage.getItem('getRecipeListing')) {
                this.setState({
                    initialData: JSON.parse(localStorage.getItem('getRecipeListing')),
                    mealSelRecp: JSON.parse(localStorage.getItem('getRecipeListing'))['result'],
                    filterGroup: JSON.parse(localStorage.getItem('getRecipeListing'))['filtergroup']
                }, () => { service.loadImages(); });
                this.totalCount = JSON.parse(localStorage.getItem('getRecipeListing'))['totalcount'];
            }
            service.hideLoader();
        }
        // service.loadImages();
        if ((this.state.recipeType == "Bookmarks" || this.state.recipeType == "bookmarks?from=app" || this.state.recipeType == "bookmarks") && this.state.initialData['msg'] == -1) {
            // document.querySelector(".recipebanner").style.display="none";
            document.querySelector(".disclaimer-con").style.display = "none";
            this.setState({ norecordFound: true });
            setTimeout(() => {
                document.querySelector('.NoRecordsCont').style.display = "block";
            }, 200);
        }
    }
    getRecipeListing() {
        var hostUrl = window.location.pathname;
        if (hostUrl.includes("/bookmark")) {
            // var url = global.api_url + "dietplan/getallbookmarkrec";
            var url = global.api_ci_url + "MealPlanner/getAllbookmark";
        } else {
            // var url = global.api_url + "dietplan/getreceipelisting";
            var url = global.api_ci_url + "MealPlanner/getRecipeList";

        }
        var postData = {
            "pageno": 1,
            "pagesize": 10
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                this.setState({ initialData: json, mealSelRecp: json['result'], filterGroup: json['filtergroup'] }, () => {
                    service.loadImages();
                    service.hideLoader();
                });
                this.totalCount = json['totalcount'];
            } else {
                if ((this.state.recipeType == "Bookmarks" || this.state.recipeType == "bookmarks?from=app" || this.state.recipeType == "bookmarks") && json['msg'] == -1) {
                    document.querySelector(".recipebanner") && (document.querySelector(".recipebanner").style.display = "none");
                    document.querySelector(".recipeBlock") && (document.querySelector(".recipeBlock").style.display = "none");
                    document.querySelector(".disclaimer-con").style.display = "none";
                    this.setState({ norecordFound: true });
                    setTimeout(() => {
                        document.querySelector('.NoRecordsCont').style.display = "block";
                    },200);
                    if (this.state.isApp && document.querySelectorAll(".mealrecipe-main").length == 0) {

                        document.querySelector('.NoRecordsCont').style.display = "block";
                        document.querySelector('.NoRecordsCont') && (document.querySelector('.main-container').style.background = "#fff");
                        var scheight = screen.height - 80 - 55;
                        document.querySelector('.NoRecordsCont') && (document.querySelector('.sub-container').style.height = scheight + "px");
                        document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.minHeight = "auto");
                        document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.height = "100%");
                        document.querySelector('.NoRecordsCont') && (document.querySelector('.NoRecordsCont').style.height = "100%");
                        document.querySelector('.NoRecordsCont') && (document.querySelector('.NoRecordsCont').style.padding = "45% 1px");
                        document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.background = "#fff");
                    }
                }else{
                    document.querySelector(".disclaimer-con").style.display = "block";
                    this.setState({ norecordFound: false });
                    setTimeout(() => {
                        document.querySelector('.NoRecordsCont').style.display = "none";
                    },200);
                }
                service.hideLoader();
            }
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    mealScrollRecp(pageno, size) {
        var hostUrl = window.location.pathname;
        if (this.state.filterCount >= 1 && !hostUrl.includes("/bookmark")) {
            var mealcourse;
            var cookingmethod;
            var mealschedule;
            var byAge;
            var typeofmeal;
            var allergen;
            var season;
            var region;
            var cooktime;

            mealcourse = localStorage.getItem('mealcourse') !="" ? localStorage.getItem('mealcourse').split(",") : [];
            cookingmethod = localStorage.getItem('cookingmethod') !="" ? localStorage.getItem('cookingmethod').split(",") : [];
            mealschedule = localStorage.getItem('mealschedule') !="" ? localStorage.getItem('mealschedule').split(",") : [];
            byAge = localStorage.getItem('byAge') !="" ? localStorage.getItem('byAge').split(",") : [];
            typeofmeal = localStorage.getItem('typeofmeal') !="" ? localStorage.getItem('typeofmeal').split(",") : [];
            allergen = localStorage.getItem('allergen') !="" ? localStorage.getItem('allergen').split(",") : [];
            season = localStorage.getItem('season') !="" ? localStorage.getItem('season').split(",") : [];
            region = localStorage.getItem('region') !="" ? localStorage.getItem('region').split(",") : [];
            cooktime = localStorage.getItem('cooktime') !="" ? localStorage.getItem('cooktime').split(",") : [];
            var url = global.api_ci_url + "api/fetchfromCI/dietplan~getreceipefilter";
            var postData = {
                "pageno": pageno,
                "pagesize": size,
                "mealcourse": mealcourse,
                "cookingmethod": cookingmethod,
                "mealschedule": mealschedule,
                "byAge": byAge,
                "typeofmeal": typeofmeal,
                "allergen": allergen,
                "season": season,
                "region": region,
                "cooktime": cooktime
            }
        } else {
            if (hostUrl.includes("/bookmark")) {
                var url = global.api_ci_url + "MealPlanner/getAllbookmark";
                // let url = global.api_url + "dietplan/getallbookmarkrec";
                var postData = {
                    "pageno": pageno,
                    "pagesize": size
                }
            } else {
                var url = global.api_ci_url + "MealPlanner/getRecipeList";
                // let url = global.api_url + "dietplan/getreceipelisting";
                var postData = {
                    "pageno": pageno,
                    "pagesize": size
                }
            }
        }
        service.postServiceCall(url, postData).then((json) => {
            console.log("json =====", json, this.state.mealSelRecp);
            if (json['msg'] == 1) {
                if (this.state.mealSelRecp.length > 0) {
                    if (size == (pageno * 10)) {
                        this.setState({ mealSelRecp: json['result'] }, () => { service.loadImages(); actions.loadReadMore(); });
                    } else {
                        let ary = this.state.mealSelRecp;
                        this.setState({ mealSelRecp: ary.concat(json['result']) }, () => { service.loadImages(); actions.loadReadMore(); });
                    }
                } else {
                    localStorage.setItem('initialData', JSON.stringify(json));
                    localStorage.setItem('filterGroup', JSON.stringify(json['filtergroup']));
                    this.totalCount = parseInt(json['totalcount']);
                    this.setState({ mealSelRecp: json['result'] }, () => { service.loadImages(); actions.loadReadMore(); });
                }
            }
            service.hideLoader();
            service.hideTracking();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
            service.hideTracking();
        });
        // }
    }
    domClick(event) {
        console.log("event Dom========>", event.target)
        if (event.target.classList.contains('share-overlay')) {
            let ary = document.getElementsByClassName('sharing-options');
            for (let i = 0; i < ary.length; i++) {
                ary[i].style.display = 'none';
            }
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'none';
            }
        } if (event.target.classList.contains('childProfile_overlay2')) {
            document.getElementsByClassName('childProfile_overlay2')[0].style.display = 'none';
        }
    }
    changeData(id, type, status, recipeType, cls) {
        let mealSelRecp = this.state.mealSelRecp;
        // console.log(mealSelRecp)
        mealSelRecp && mealSelRecp.forEach((recipe) => {
            if (recipe.recipeId == id || recipe.mealId == id || recipe.recId == id) {
                if (type == "bookmark") {
                    if (parseInt(status) == 1) {
                        // console.log("successss====>",recipe.articleId);
                        recipe.isBookmarked = 1;
                        // recipe.bookmarkCount = parseInt(recipe.bookmarkCount) + 1;
                    } else if (parseInt(status) == 0) {
                        recipe.isBookmarked = 0;
                        if (recipeType == "bookmarks" || recipeType == "Bookmarks") {
                            // document.getElementById(cls).remove();
                            if (document.querySelectorAll(".mealrecipe-main").length == 1) {
                                this.getRecipeListing();
                            }
                            var minheightdata1 = window.innerHeight - 120;
                            if (this.state.isApp && document.querySelector(".data-container").scrollHeight < minheightdata1 && (this.state.recipeType == "Bookmarks" || this.state.recipeType == "bookmarks?from=app")) {
                                document.querySelector('.disclaimer-con').style.marginBottom = "31px";
                                document.querySelector('.main-container').style.background = "#eee"
                                document.querySelector('.disclaimer-con').style.width = "100%";
                                document.querySelector('.disclaimer-con').style.position = "fixed";
                                document.querySelector('.data-container').style.background = "#fff";
                                document.querySelector('.recipeBlock').style.border = "none";
                                document.querySelector('.disclaimer-con').style.bottom = "40px";
                                var scheight = screen.height - 80 - 55;
                                // document.querySelector('.sub-container') && (document.querySelector('.sub-container').style.height = scheight + "px");
                                document.querySelector('.sub-container') && (document.querySelector('.sub-container').style.height = "auto");
                            }
                        }
                        // recipe.bookmarkCount = parseInt(recipe.bookmarkCount) - 1;
                    }
                } else if (type == "Like") {
                    if (parseInt(status) == 1) {
                        recipe.isLike = 1;
                        recipe.likeCount = parseInt(recipe.likeCount) + 1;
                    }
                }
            }
        });
        this.setState({ mealSelRecp: mealSelRecp });
    }
    openMealPopupSlider(event, e) {
        document.querySelector('.mp-slider').style.display = 'none';
        for (let i = 1; i < 4; i++) {
            if (document.getElementById('mp-slider' + i).style.display == 'block') {
                document.getElementById('mp-slider' + i).style.display == 'none';
            }
        }
        if (e == 'up') {
            document.getElementById('mp-slider' + event).style.display = 'block';
            document.getElementById('mpup' + event).style.display = 'none';
            document.getElementById('mpdown' + event).style.display = 'block';
        } else {
            document.getElementById('mpdown' + event).style.display = 'none';
            document.getElementById('mp-slider' + event).style.display = 'none';
            document.getElementById('mpup' + event).style.display = 'block';
        }
    }
    rateRecipe() {
        if (this.state.isApp) {
            var screenName = 'Recipe Listing';
            var eventName = 'Meal Planner |' + screenName + 'Filter Actions';
            var obj = {};
            obj.gaObj = eventName+"_Filter Open";
                // "eventdata": {
                //     "event_action": "Filter Open",
                //     "event_label": ""
                // }
            actions.trackEvent(obj);
        }
        document.getElementsByClassName('filter-overlay')[0].style.display = 'block';
        document.querySelector('body').style.overflow = "hidden";
        if (document.getElementsByClassName('toggle-main') && document.getElementsByClassName('toggle-main')[0]) {
            document.getElementsByClassName('toggle-main')[0].style.display = 'none';
        }
        Cookies.set('Meal_filters', true);
        actions.showSubCat("by0");
        if (this.state.filterCount != 0) {
            actions.filterToCategory("subby0", "byAge");
            actions.filterToCategory("submeal1", "mealschedule");
            actions.filterToCategory("subtype2", "typeofmeal");
            actions.filterToCategory("submeal3", "mealcourse");
            actions.filterToCategory("subcooking4", "cookingmethod");
            actions.filterToCategory("subcooking5", "cooktime");
            actions.filterToCategory("suballergen6", "allergen");
            actions.filterToCategory("subseason7", "season");
            actions.filterToCategory("subregion8", "region");
        }
    }
    onclosePopup() {
        if (this.state.isApp) {
            var ScreenName = 'Recipe Listing';
            var eventName = 'Meal Planner |' + ScreenName + 'Filter Actions';
            var obj = {};
            obj.gaObj = eventName+"_Close";
                // "eventdata": {
                //     "event_action": "Close",
                //     "event_label": ""
                // }
            trackEvent(obj);
        }
        document.getElementsByClassName('filter-overlay')[0].style.display = 'none';
        document.querySelector('body').style.overflow = "visible";
        if (window.innerWidth < 767 && document.getElementsByClassName('toggle-main') && document.getElementsByClassName('toggle-main')[0]) {
            document.getElementsByClassName('toggle-main')[0].style.display = 'block';
        }
        Cookies.set('Meal_filters', false);

    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.pageData, false);
        document.removeEventListener("click", actions.domClick);
    }
    pageData() {
        // var hostUrl = window.location.pathname;
        // if (hostUrl.includes("/bookmark")) {
        //     service.hideLoader();
        //     service.hideTracking();
        // } else {
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            if (document.getElementsByClassName('data-container')[0]) {
                var cS = document.getElementsByClassName('data-container')[0].offsetTop;
                var cH = document.getElementsByClassName('data-container')[0].offsetHeight - 2000,
                    wS = window.scrollY - cS;
                    var checkVal = _this.state.isApp ? ((window.innerHeight + window.scrollY) > document.body.offsetHeight):( (window.innerHeight + window.scrollY) >= document.body.offsetHeight);
                if (!(checkVal) && wS > cH) {
                    if (wS > _this.maxScroll && _this.totalCount > (_this.qnaPageNo * 10)) {
                        _this.maxScroll = wS;
                        ++_this.qnaPageNo;
                        service.showLoader();
                        service.showTracking();
                        document.getElementById('pgNo').value = _this.qnaPageNo;
                        _this.mealScrollRecp(_this.qnaPageNo, 10);
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
        // }
    }
    closechildPopup(cls) {
        document.getElementsByClassName(cls)[0].style.display = 'none';
    }
    render() {
        return (
            <main className="main-container meal-planner">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                {!this.state.isApp &&
                    <div className="title">
                        <div className="breadcrumb R11_9e">
                            <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span><a href={global.redirect_url + "tools/baby-meal-plan"} className="R11_9e">Baby Meal Planner</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            {this.state.recipeType != "Bookmarks" || this.state.recipeType != "bookmarks" ?
                                <span>{this.state.recipeType} Recipes</span>
                                :
                                <span>Bookmarks</span>
                            }
                        </div>
                        {this.state.recipeType != "Bookmarks" && this.state.recipeType != "bookmarks" ?
                            <h1 className="B24_00" id="skipToH1" tabIndex={0}>{this.state.recipeType} Recipes for Babies & Toddlers</h1>
                            :
                            <h1 className="B24_00" id="skipToH1" tabIndex={0}>Bookmarks</h1>
                        }
                    </div>
                }
                {this.state.isApp &&
                    <div className="app-header">
                        <span data-icon-font="s" className="icon" onClick={() => onBackPressed()}></span>
                        {this.state.recipeType != "Bookmarks" && this.state.recipeType != "bookmarks" ?
                            <span className="M16_pink">Recipe Listings </span>
                            :
                            <span className="M16_pink">Bookmarks</span>
                        }
                    </div>
                }
                <div className="sub-container left recipe-list-cont" style={this.state.isApp ? { marginTop: '50px' } : {}}>
                    <div className="data-container left">
                        {this.state.initialData && this.state.initialData['msg'] != -1 &&
                            <div className="meal-planner-banner recipebanner">
                                <div className="bannerimg">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/listing-page_bg.png" />
                                </div>
                                {this.state.filterGroup && this.state.filterGroup != '' &&
                                    <div className="filterblock" onClick={() => { this.rateRecipe() }}>
                                        <span className="filtertext R24_FF left">filter</span>
                                        <span className="filtercount R24_FF left">({this.state.filterCount})</span>
                                        <span className="R24_FF filtericon icon left" data-icon-font="K" ></span>
                                    </div>
                                }
                            </div>
                        }
                        {this.state.initialData && this.state.initialData['msg'] != '-1' &&
                            <div className="recipeBlock">
                                <MealRecipe mealSelRecp={this.state.mealSelRecp} eleRef={this} flag={"Recipe"} recipeType={this.state.recipeType} isApp={this.state.isApp} />
                                <input type="hidden" id="pgNo" value="" />
                            </div>
                        }
                        {this.state.norecordFound &&
                            <div className="NoRecordsCont">
                                <div className="recordImg">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/BookmarkEmpty.png" />
                                    
                                </div>
                                <div className="recoedText bktext">Seems like you haven't bookmarked any recipe yet.</div>
                            </div>
                        }
                        {this.state.norecordFoundFilter &&
                            <div className="NoRecordsCont">
                                <div className="recordImg">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/GroceryListEmpty.png" />

                                </div>
                                <div className="recoedText bktext">No recipes found for selected filter.</div>
                            </div>
                        }
                        {this.state.filterGroup && this.state.filterGroup != '' ?
                            <FooterMenu eleRef={this} flag="RL" isApp={this.state.isApp} />
                            :
                            <FooterMenu eleRef={this} flag="BM" isApp={this.state.isApp} />
                        }
                    </div>
                    {this.state.filterGroup && this.state.filterGroup != '' &&
                        <FilterCategory FilterData={this.state.filterGroup[0]} filterCount={this.state.filterCount} eleRef={this} isApp={this.state.isApp} />
                    }
                </div>
                <div className="childProfile_overlay2">
                    <div className="popup tbmargin">
                        <span className="close_icon icon right R14_9e" data-icon-font="C" onClick={() => { this.closechildPopup("childProfile_overlay2") }}></span>
                        <div className="agetext R14_42">There are no bookmark in Mybookmark Page</div>
                    </div>
                </div>
                <div className="new-right-sect">
                    <Right url={this.props.location.pathname} />
                </div>
            </main>
        )
    }
}

export default withContext(Recipe);
